export function formatDate(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function formatPlans(plans: string[]) {
  if (plans.length === 0) return 'All plans'
  return plans
    .map(plan => plan.charAt(0).toUpperCase() + plan.slice(1))
    .join(' / ')
}

export function estimateReadMinutes(html: string) {
  const words = html
    .replace(/<[^>]+>/g, ' ')
    .split(/\s+/)
    .filter(Boolean).length
  return Math.max(1, Math.round(words / 220))
}

export function slugifyHeading(text: string, used: Map<string, number>) {
  const base =
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section'
  const count = used.get(base) ?? 0
  used.set(base, count + 1)
  return count === 0 ? base : `${base}-${count}`
}

/**
 * Gives every h2/h3 in the article a stable id (server and client alike) so
 * the table of contents and deep links work in prerendered HTML too.
 */
export function addHeadingIds(html: string) {
  const used = new Map<string, number>()
  return html.replace(
    /<(h[23])\b([^>]*)>([\s\S]*?)<\/\1>/gi,
    (match, tag: string, attrs: string, inner: string) => {
      if (/\sid=/.test(attrs)) return match
      const text = inner.replace(/<[^>]+>/g, '')
      const id = slugifyHeading(text, used)
      return `<${tag}${attrs} id="${id}">${inner}</${tag}>`
    },
  )
}

export interface HeadingItem {
  id: string
  text: string
  depth: 0 | 1
}

export function extractHeadings(html: string): HeadingItem[] {
  const items: HeadingItem[] = []
  const pattern = /<(h[23])\b[^>]*\sid="([^"]+)"[^>]*>([\s\S]*?)<\/\1>/gi
  let match: RegExpExecArray | null
  while ((match = pattern.exec(html))) {
    const [, tag = '', id = '', inner = ''] = match
    const text = inner.replace(/<[^>]+>/g, '').trim()
    if (!text || !id) continue
    items.push({ id, text, depth: tag === 'h2' ? 0 : 1 })
  }
  return items
}
